<div class="login-page">
  <div class="login-card">
    <h1 class="login-card__title">Bienvenu(e)</h1>
    <p class="login-card__subtitle">Entrez vos identifiants et continuez</p>

    <form class="login-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="field-group">
        <app-phone-input
          #phoneInput
          formControlName="phone"
          inputId="login-phone"
          [invalid]="form.controls.phone.touched && form.controls.phone.invalid" />
        <span class="field-error" *ngIf="getPhoneError() as phoneError">{{ phoneError }}</span>
      </div>

      <div class="field-group">
        <div
          class="field field--password"
          [class.field--invalid]="form.controls.password.touched && form.controls.password.invalid">
          <mat-icon class="field__icon" aria-hidden="true">lock</mat-icon>
          <input
            class="field__input"
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            placeholder="Mot de passe"
            autocomplete="current-password" />
          <button
            class="field__toggle"
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
        <span class="field-error" *ngIf="form.controls.password.touched && form.controls.password.hasError('required')">
          Le mot de passe est requis
        </span>
      </div>

      <div class="login-options">
        <label class="login-options__remember">
          <input type="checkbox" formControlName="rememberMe" />
          <span>Se souvenir de moi</span>
        </label>
        <a class="login-options__forgot" routerLink="/mot-de-passe-oublie">Mot de passe oublié ?</a>
      </div>

      <p class="login-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

      <button class="login-submit" type="submit" [disabled]="loading">
        {{ loading ? 'Connexion…' : 'Se connecter' }}
      </button>
    </form>

    <div class="login-signup">
      <p class="login-signup__prompt">Vous n'avez pas de compte ?</p>
      <div class="login-signup__divider">
        <span class="login-signup__line"></span>
        <a class="login-signup__link" routerLink="/inscription">Inscrivez-vous</a>
        <span class="login-signup__line"></span>
      </div>
    </div>
  </div>
</div>
